 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"admin-faq-admin-faq-module":"admin-faq-admin-faq-module","auth-auth-module":"auth-auth-module","common":"common","add-plan-add-plan-module":"add-plan-add-plan-module","admin-cms-admin-cms-module":"admin-cms-admin-cms-module","admin-specialties-admin-specialties-module":"admin-specialties-admin-specialties-module","doctor-appointments-doctor-appointments-module":"doctor-appointments-doctor-appointments-module","doctor-detail-doctor-detail-module":"doctor-detail-doctor-detail-module","doctor-profile-doctor-profile-module":"doctor-profile-doctor-profile-module","edit-plan-edit-plan-module":"edit-plan-edit-plan-module","hospital-appointments-hospital-appointments-module":"hospital-appointments-hospital-appointments-module","hospital-doctors-hospital-doctors-module":"hospital-doctors-hospital-doctors-module","hospital-insurance-hospital-insurance-module":"hospital-insurance-hospital-insurance-module","manage-doctors-manage-doctors-module":"manage-doctors-manage-doctors-module","manage-hospital-manage-hospital-module":"manage-hospital-manage-hospital-module","manage-patients-manage-patients-module":"manage-patients-manage-patients-module","patient-details-patient-details-module":"patient-details-patient-details-module","default~admin-admin-module~doctor-doctor-module~doctor-edit-profile-doctor-edit-profile-module~front~d83f33c6":"default~admin-admin-module~doctor-doctor-module~doctor-edit-profile-doctor-edit-profile-module~front~d83f33c6","frontend-frontend-module":"frontend-frontend-module","hospital-settings-hospital-settings-module":"hospital-settings-hospital-settings-module","default~admin-admin-module~doctor-doctor-module~hospital-hospital-module":"default~admin-admin-module~doctor-doctor-module~hospital-hospital-module","admin-admin-module":"admin-admin-module","doctor-doctor-module":"doctor-doctor-module","hospital-hospital-module":"hospital-hospital-module","default~doctor-edit-profile-doctor-edit-profile-module~hospital-profile-hospital-profile-module~mana~81cba5e3":"default~doctor-edit-profile-doctor-edit-profile-module~hospital-profile-hospital-profile-module~mana~81cba5e3","doctor-edit-profile-doctor-edit-profile-module":"doctor-edit-profile-doctor-edit-profile-module","hospital-profile-hospital-profile-module":"hospital-profile-hospital-profile-module","default~admin-dashboard-admin-dashboard-module~doctor-dashboard-doctor-dashboard-module~hospital-das~a6a32a32":"default~admin-dashboard-admin-dashboard-module~doctor-dashboard-doctor-dashboard-module~hospital-das~a6a32a32","admin-dashboard-admin-dashboard-module":"admin-dashboard-admin-dashboard-module","doctor-dashboard-doctor-dashboard-module":"doctor-dashboard-doctor-dashboard-module","hospital-dashboard-hospital-dashboard-module":"hospital-dashboard-hospital-dashboard-module","manage-insurance-manage-insurance-module":"manage-insurance-manage-insurance-module","default~doctor-schedules-doctor-schedules-module~hospital-detail-hospital-detail-module~hospital-doc~86c281ab":"default~doctor-schedules-doctor-schedules-module~hospital-detail-hospital-detail-module~hospital-doc~86c281ab","doctor-schedules-doctor-schedules-module":"doctor-schedules-doctor-schedules-module","hospital-detail-hospital-detail-module":"hospital-detail-hospital-detail-module","hospital-doctor-shedules-hospital-doctor-shedules-module":"hospital-doctor-shedules-hospital-doctor-shedules-module","subscription-plan-subscription-plan-module":"subscription-plan-subscription-plan-module","hospital-doctor-profile-hospital-doctor-profile-module":"hospital-doctor-profile-hospital-doctor-profile-module"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
